function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.to-string.js";
var _this = this;
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import ContentHandler from '../common/classes/ContentHandler';

/**
 * @param {HTMLELement} element
 */
var $callback = function $callback(element) {
  var button = document.querySelector('span.js-content-loader');
  if (button && element.value !== '') {
    var srcContent = button.dataset.srcContent;
    var _srcContent$split = srcContent.split('&' + opusUniverseFilter + ':'),
      _srcContent$split2 = _slicedToArray(_srcContent$split, 2),
      url = _srcContent$split2[0],
      univers = _srcContent$split2[1];
    var encodeUrl = "".concat(url).concat(opusUniverseFilter, ":").concat(encodeURIComponent(univers));
    button.dataset.srcContent = encodeUrl;
  }
};

/**
 * @param {HTMLElement} element
 */
var $filter = function $filter(element) {
  var filterValue = encodeURIComponent(opusUniverseFilter + ":" + element.value);
  var divParent = document.querySelector('div.js-select-wrapper');
  var srcContent = divParent.dataset.srcContent;
  var filterUrl = '/magazine/reload/listhowtochoose/howtochoose?p=1&size=15' + '&categoryId=' + srcContent;
  var url = filterValue ? "".concat(filterUrl, "&filter=").concat(filterValue) : filterUrl;
  lm.fetch({
    url: url,
    success: function success(data) {
      document.querySelector('.js-content-loader-container').innerHTML = data;
      new ContentHandler('Comment choisir');
      $callback.call(_this, element);
    },
    complete: lm.lazyload.observe
  });
  currentPage = minPage;
  if (filterValue !== "") {
    window.history.replaceState("", "", "?p=" + currentPage + "&filter=" + filterValue);
  } else {
    window.history.replaceState("", "", "?p=" + currentPage);
  }
};
var magazineListHowToChoose = /*#__PURE__*/function (_lm$Composant) {
  /**
   * @constructor
   * @param {String} id
   */
  function magazineListHowToChoose(id) {
    var _this2;
    _classCallCheck(this, magazineListHowToChoose);
    _this2 = _callSuper(this, magazineListHowToChoose, [id]);

    // Init filter param
    var url = new URL(document.location);
    var filterParam = url.searchParams.get("filter");

    // Init pagination display
    var paginationParam = new URL(document.location).searchParams.get("p");
    scrollMagazineListHowToChooseIntoView();
    initBrowserUrl();
    new ContentHandler('Comment choisir');

    // Init code
    var jsFilterWrapper = _this2.target.querySelector('.js-filter-wrapper');
    if (jsFilterWrapper) {
      jsFilterWrapper.addEventListener('change', function (e) {
        $filter.call(_this2, e.target);
      });
    }
    function scrollMagazineListHowToChooseIntoView() {
      if (paginationParam) {
        document.querySelector('.js-content-loader-container').scrollIntoView();
      }
    }
    function initBrowserUrl() {
      if (paginationParam) {
        if (filterParam) {
          window.history.replaceState("", "", "?p=" + currentPage + "&filter=" + url.search.slice(url.search.indexOf("filter=") + "filter=".length));
        } else {
          window.history.replaceState("", "", "?p=" + currentPage);
        }
      }
    }
    return _this2;
  }
  _inherits(magazineListHowToChoose, _lm$Composant);
  return _createClass(magazineListHowToChoose);
}(lm.Composant);
lm.DOMReady(function () {
  new magazineListHowToChoose('magazinelisthowtochoose');
});